var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasContent)?_c('div',{staticClass:"Iframe"},[(_vm.content.src)?_c('iframe',{staticClass:"iframe-content",style:(_vm.content.height ? ("height: " + (_vm.content.height) + "px;") : ''),attrs:{"src":_vm.content.src}}):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }